<h1 mat-dialog-title>Clone Existing Route Configuration</h1>

<mat-dialog-content>
  <p>

  </p>
  <mat-form-field class="w-100">
    <mat-label>Route Configuration Name</mat-label>
    <input matInput
           [ngModel]="data"
    />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close cdkFocusInitial>
    Cancel
  </button>
  <button mat-flat-button [mat-dialog-close]="data">
    Clone
  </button>
</mat-dialog-actions>
